const {
  zipCodeRegexNumeric,
  onlyNumericNormalize,
  SPACE
} = require('../helpers');

exports.zipCodeNormalize = (zipCode) => onlyNumericNormalize(zipCode, 3);

exports.countryDefinition = {
  country: 'Madagascar',
  code: 'MG',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Block name + House no + District' },
    address2: { label: 'Postal Town' },
    city: { label: 'Town', width: 0.5 },
    zipCode: {
      label: 'Postcode',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  viewFormat: [
    ['company'],
    ['address'],
    ['city'],
    ['zipCode', SPACE, 'address2']
  ],
  formFormat: [['company'], ['address'], ['city'], ['zipCode', 'address2']],
  requiredFormFields: [
    { field: 'address' },
    { field: 'address2' },
    { field: 'city' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(zipCodeRegexNumeric(3)),
      error: 'Must be 3 characters, 501'
    }
  ]
};
